<template>
    <div class="auth-wrapper auth-v2 bg-white">
        <b-row class="auth-inner m-0 bg-white">
            <div class="w-100 d-flex flex-column  bg-white">

                <!-- Advice collapse -->
                <div class="headTitle mt-5 ml-2">Asesoría</div>
                <app-collapse accordion class=" ml-3">
                    <app-collapse-item title="Asesoría 1">
                        Tiramisu marshmallow dessert halvah bonbon cake gingerbread. Jelly beans chocolate pie powder. Dessert pudding chocolate cake bonbon bear claw cotton candy cheesecake. Biscuit fruitcake macaroon carrot cake. Chocolate cake bear claw muffin chupa chips pudding. Pastry bear claw danish cake caramels topping dessert marzipan gingerbread. 
                    </app-collapse-item>
                    <app-collapse-item title="Asesoría 2">
                      Tiramisu marshmallow dessert halvah bonbon cake gingerbread. Jelly beans chocolate pie powder. Dessert pudding chocolate cake bonbon bear claw cotton candy cheesecake. Biscuit fruitcake macaroon carrot cake. Chocolate cake bear claw muffin chupa chips pudding. Pastry bear claw danish cake caramels topping dessert marzipan gingerbread. 
                    </app-collapse-item>
                    <app-collapse-item title="Asesoría 3">
                        Tiramisu marshmallow dessert halvah bonbon cake gingerbread. Jelly beans chocolate pie powder. Dessert pudding chocolate cake bonbon bear claw cotton candy cheesecake. Biscuit fruitcake macaroon carrot cake. Chocolate cake bear claw muffin chupa chips pudding. Pastry bear claw danish cake caramels topping dessert marzipan gingerbread. 
                    </app-collapse-item>
                </app-collapse>
            </div>
        </b-row>
        <ControlMenu />
    </div>
</template>

<script>
import { BRow, BCol, BLink, } from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import ControlMenu from '@/components/ControlMenu.vue'
export default {
    components: {
        AppCollapse,
        AppCollapseItem,
        ControlMenu,
        BRow,
    },
}
</script>

<style>
.headTitle {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;

}
#app {
    background-color: white;
}
</style>